// import { parsePhoneNumber } from "libphonenumber-js";
import { appUrl } from "@src/app/constants";
var CryptoJS = require("crypto-js");

export const navigateTo = ({ path }) => {
    window.location.href = `${appUrl}${path}`;
};

export const openInNewTab = ({ path, absolute }) => {
    let url = absolute ? path : `${appUrl}${path}`;
    window.open(url, "_blank").focus();
};

export const is = (() => {
    function getType(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1);
    }
    function is(type, obj) {
        var clas = getType(obj);
        return obj !== undefined && obj !== null && clas === type;
    }
    is.Email = function (obj) {
        return is.String(obj) && obj.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    };
    is.Function = function (obj) {
        return is("Function", obj);
    };
    is.Object = function (obj) {
        return is("Object", obj);
    };
    is.Array = function (obj) {
        return is("Array", obj);
    };
    is.Null = function (obj) {
        return is("Null", obj);
    };
    is.Undefined = function (obj) {
        return getType(obj) === "Undefined";
    };
    is.Number = function (obj) {
        return is("Number", obj);
    };
    is.String = function (obj) {
        return is("String", obj);
    };
    is.Value = function (obj) {
        var clas = getType(obj);
        return !(clas === "Undefined" || clas === "Null");
    };
    is.Empty = function (obj) {
        // Doesn't work for Date Objects
        var clas = getType(obj);
        switch (clas) {
            case "Undefined":
            case "Null":
                return true;
            case "Boolean":
                return obj;
            case "Number":
                return obj === 0;
            case "String":
            case "Array":
                return obj.length === 0;
            default:
                for (var key in obj) {
                    if (hasOwnProperty.call(obj, key)) return false;
                }
                return true;
        }
        return !(is.Undefined(obj) || is.Null(obj));
    };
    is.Valid = function (condition, message) {
        if (!condition && is.String(message)) {
            throw Error(message);
        }
        return !!condition;
    };
    return is;
})();

export function debounce(fn, delay, fn2) {
    var timer = null;
    return function () {
        var context = this,
            args = arguments;
        if (typeof fn2 === "function") fn2.apply(context, args);
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

export function throttle(fn, wait) {
    let inThrottle, lastFn, lastTime;
    return function () {
        const context = this,
            args = arguments;
        if (!inThrottle) {
            fn.apply(context, args);
            lastTime = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFn);
            lastFn = setTimeout(function () {
                if (Date.now() - lastTime >= wait) {
                    fn.apply(context, args);
                    lastTime = Date.now();
                }
            }, Math.max(wait - (Date.now() - lastTime), 0));
        }
    };
}

export function notify(title, msg) {
    let notification;
    let options = {};
    if (msg) options.body = msg;
    if (!("Notification" in window)) {
        console.error("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
        notification = new Notification(title, options);
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
                notification = new Notification(title, options);
            }
        });
    }
    return notification;
}

export function param(obj) {
    let app = {},
        class2type = {},
        toString = class2type.toString,
        r20 = /%20/g,
        rbracket = /\[\]$/;

    function type(obj) {
        if (obj == null) {
            return obj + "";
        }
        // Support: Android < 4.0, iOS < 6 (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function"
            ? class2type[toString.call(obj)] || "object"
            : typeof obj;
    }

    function isFunction(obj) {
        return type(obj) === "function";
    }

    function buildParams(prefix, obj, add) {
        var name, key, value;

        if (Array.isArray(obj)) {
            for (var key in obj) {
                value = obj[key];
                if (rbracket.test(prefix)) add(prefix, value);
                else buildParams(prefix + "[" + (typeof v === "object" ? i : "") + "]", value, add);
            }
        } else if (type(obj) === "object") {
            for (name in obj) buildParams(prefix + "[" + name + "]", obj[name], add);
        } else add(prefix, obj);
    }

    function param(obj) {
        var prefix,
            key,
            value,
            serialized = [],
            add = function (key, value) {
                value = isFunction(value) ? value() : value == null ? "" : value;
                serialized[serialized.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
            };

        if (Array.isArray(obj)) {
            for (key in obj) {
                value = obj[key];
                add(key, value);
            }
        } else {
            for (prefix in obj) buildParams(prefix, obj[prefix], add);
        }
        return serialized.join("&").replace(r20, "+");
    }
    return param(obj);
}

export function exportToCSV(rows) {
    let csvContent = "data:text/csv;charset=utf-8,";
    rows.forEach(function (rowArray) {
        rowArray = rowArray.map(cell => `"${cell}"`);
        let row = rowArray.join(",");
        csvContent += row + "\r\n"; // add carriage return
    });
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "transaction_history.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
}

export function toTitleCase(str) {
    if (!str) return "";
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function toSentenceCase(str) {
    if (!str) return "";
    return str.trim().charAt(0).toUpperCase() + str.trim().substr(1).toLowerCase();
}

/**
 * Breaks sentences into lines
 * add "style={{ whiteSpace: "pre-line"}}" to for proper sentence break
 */
export function sentenceToLines(sentence) {
    if (typeof sentence !== "string") return sentence;

    // const parts = sentence.split(".").filter(Boolean);
    // return parts.map(part => `${part.trim()}.`).join("\n");
    //separate sentences on the basis of "." and capital letters
    return (
        sentence
            // Split on a dot followed by optional spaces + a capital letter
            .split(/\. *(?=[A-Z])/)
            .map(s => s.trim())
            .filter(Boolean)
            .map(s => (s.endsWith(".") ? s : s + "."))
            .join("\n")
    );
}

export function toCapitalise(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function numberWithCommas(x) {
    if (isNaN(x) || x === null) return "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function round(number, precision) {
    if (precision === undefined) return number;
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
}

export function roundDown(number, precision) {
    if (precision === undefined) return number;
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = -Math.round(-tempNumber);
    return roundedTempNumber / factor;
}

export function roundedWithCommas(number, precision) {
    if (isNaN(number) || number === null) return "";
    return numberWithCommas(round(number, precision));
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function createFormData(obj, form, namespace) {
    let fd = form || new FormData();
    let formKey;

    for (let property in obj) {
        if (obj.hasOwnProperty(property) && obj[property]) {
            if (namespace) {
                formKey = namespace + "[" + property + "]";
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File, use recursivity.
            if (typeof obj[property] === "object" && !(obj[property] instanceof File)) {
                createFormData(obj[property], fd, formKey);
            } else {
                // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }

    return fd;
}

export function flattenObject(obj) {
    let newObj = {};

    function dive(currentKey, into, target) {
        for (let i in into) {
            if (into.hasOwnProperty(i)) {
                let newKey = i;
                let newVal = into[i];

                if (currentKey.length > 0) {
                    newKey = currentKey + "." + i;
                }

                if (typeof newVal === "object") {
                    dive(newKey, newVal, target);
                } else {
                    target[newKey] = newVal;
                }
            }
        }
    }
    dive("", obj, newObj);
    return newObj;
}

export function clone(obj) {
    return is.Object(obj) || is.Array(obj) ? JSON.parse(JSON.stringify(obj)) : obj;
}

export function openPopup(url) {
    return window.open(
        url,
        "Login with ",
        `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`
    );
}

export function classnames(permanentClasses, conditionalClasses) {
    return Object.keys(conditionalClasses).reduce((finalClasses, nextClassName) => {
        return conditionalClasses[nextClassName] ? finalClasses.concat(" ", nextClassName) : finalClasses;
    }, permanentClasses);
}

export function isValidPAN(val) {
    let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    return regpan.test(val.trim());
}

export function isValidAadhaar(val) {
    let regEx = /^\d{12}$/;
    return regEx.test(val.trim());
}

export function isValidGST(val) {
    let reggst = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return reggst.test(val.trim().toUpperCase());
}

export function objectFromArrayOfKeys(arr, val){
    let finalObj;
    arr.reverse().map((key,i) => {
      let temp = {};
      if(i === 0){
        temp[key] = val;
      } else {
        temp[key] = finalObj;
      }
      finalObj = temp;
    });
    return finalObj;
}

export function getAddressString(address, avoidBreak) {
    var addStr = "";
    if (!is.Empty(address)) {
        addStr = address.line1.replace(/,\s*$/, "");
        if (!is.Empty(address.line2))
            addStr += (!is.Empty(addStr) ? (avoidBreak ? ", " : ", \n") : "") + address.line2.replace(/,\s*$/, "");
        if (!is.Empty(address.line3))
            addStr += (!is.Empty(addStr) ? (avoidBreak ? ", " : ", \n") : "") + address.line3.replace(/,\s*$/, "");
        if (!is.Empty(address.city)) addStr += (!is.Empty(addStr) ? (avoidBreak ? ", " : ", \n") : "") + address.city;
        if (!is.Empty(address.postal_code))
            addStr += (!is.Empty(addStr) ? " - " : "") + address.postal_code.replace(/,\s*$/, "");
        if (!is.Empty(address.state)) addStr += (!is.Empty(addStr) ? (avoidBreak ? ", " : ", \n") : "") + address.state;
        if (!is.Empty(address.country))
            addStr +=
                (!is.Empty(addStr) ? ", " : "") +
                (!is.Empty(address.country_name) ? address.country_name : address.country);
    }
    return addStr;
}

// pass mobile number with isd code
//   export function getformattedPhoneNum(num) {
//     let _num = num.startsWith("+") ? num : `+${num}`
//     const phoneNumber = parsePhoneNumber(_num)
//     return phoneNumber.formatInternational()
//   }

export function removeEmoji(str) {
    //return str.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]|[\uF600–\uF64F])/g, '');
    return str.replace(
        /[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2580-\u27BF]|\uD83E[\uDD10-\uDDFF]/g,
        ""
    );
}

export { default as CacheUtil } from "./CacheUtil";

export { default as ErrorUtil } from "./ErrorUtil";

export function getSecretKeys(pubKey = "") {
    const encrypted = document.querySelector('[name="cacc"]').content;
    const Key = CryptoJS.enc.Utf8.parse(pubKey);
    const hash = CryptoJS.TripleDES.decrypt(encrypted, Key, {
        mode: CryptoJS.mode.ECB
    });
    let result = {};
    try {
        result = JSON.parse(hash.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error("failed to read secret keys");
    }
    console.log("getSecretKeys invoked", result);
    return result;
}


export function resizeImage(base64Str, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function() {
            let width = img.width;
            let height = img.height;

            // Calculate new dimensions
            if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
            }
            if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
            }

            // Create canvas
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;

            // Draw image on canvas
            ctx.drawImage(img, 0, 0, width, height);

            // Get resized image as base64 string
            const resizedBase64 = canvas.toDataURL('image/jpeg');

            resolve(resizedBase64);
        };
        img.onerror = reject;
        img.src = base64Str;
    });
}

// Function to compress base64 image under 1MB
export async function compressImage(base64Str) {
    let resizedBase64 = base64Str;
    let fileSizeInBytes = resizedBase64.length * 3 / 4; // Approximate size in bytes

    // Reduce size until it's below 1MB
    while (fileSizeInBytes > 1024 * 1024) {
        resizedBase64 = await resizeImage(resizedBase64, 800, 600); // Resize to fit within 800x600
        fileSizeInBytes = resizedBase64.length * 3 / 4;
    }

    // Return compressed base64 image
    return resizedBase64;
}

export function rotateImage180(base64Str) {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = img.width;
            canvas.height = img.height;

            // Rotate 180°
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(Math.PI);

            ctx.drawImage(
                img,
                -img.width / 2,
                -img.height / 2,
                img.width,
                img.height
            );

            // Remove the data URL prefix since your app stores raw Base64
            const rotatedBase64 = canvas
                .toDataURL("image/jpeg", 0.9)
                .replace(/^data:image\/jpeg;base64,/, "");

            resolve(rotatedBase64);
        };

        img.onerror = (err) => {
            console.error("Failed to load image", err);
            reject(err);
        };

        // Add prefix only if it doesn't already exist
        img.src = base64Str.startsWith("data:")
            ? base64Str
            : `data:image/jpeg;base64,${base64Str}`;
    });
}


const Utils = {
    toTitleCase,
    debounce,
    getParameterByName
};

export default Utils;
